
/**
 * Formats time in seconds to MM:SS format
 * @param timeInSeconds Time in seconds
 * @returns Formatted time string (MM:SS)
 */
export const formatTime = (timeInSeconds: number): string => {
  if (isNaN(timeInSeconds)) return '00:00';
  const minutes = Math.floor(timeInSeconds / 60);
  const seconds = Math.floor(timeInSeconds % 60);
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};
